import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import Button from '@swf/components/StarsButton/StarsButton';
import { useHomeGamesWidget } from '@swf/poker';

import { TXTCLI_Play_Money, TXTCLI_Real_Money } from './CurrencySwitch.messages.json';
import styles from './CurrencySwitch.scss';

interface Props {
  className?: string;
}

const CurrencySwitch: React.FC<Props> = ({ className }) => {
  const { widgetSelect, widgetDispatch } = useHomeGamesWidget();
  const { standingsPlayMoneyFlag } = useSelector(widgetSelect.uiLayout);
  return (
    <div className={classNames(styles.container, className)}>
      <div className={classNames(styles.item, { [styles.active]: !standingsPlayMoneyFlag })}>
        <Button
          variant="text"
          translation={TXTCLI_Real_Money}
          onClick={() =>
            widgetDispatch.setUiLayout({ key: 'standingsPlayMoneyFlag', value: false })
          }
        />
      </div>
      <div className={classNames(styles.item, { [styles.active]: standingsPlayMoneyFlag })}>
        <Button
          variant="text"
          translation={TXTCLI_Play_Money}
          onClick={() => widgetDispatch.setUiLayout({ key: 'standingsPlayMoneyFlag', value: true })}
        />
      </div>
    </div>
  );
};

export default CurrencySwitch;
